var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"pb-0 hidden-sm-and-down",attrs:{"lg":"6","md":"5"}},[_c('v-img',{staticClass:"sticky-image",attrs:{"height":"100vh","src":_vm.createAccountImage}})],1),_c('AussieTimeRegistration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }